import { z } from 'zod'

export const PASSWORD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*])(?=.{8,128}$)/

export const PASSWORD_VALIDATION_MESSAGE = 'Password should contain symbols, uppercase letters, lowercase letters, numbers, and special characters'

export const USERNAME_REGEX = /^[a-zA-Z0-9_-]{3,50}$/

export const USERNAME_VALIDATION_MESSAGE = 'Username must be 3–50 characters and contain only letters, numbers, underscore, or hyphen'

export function isUsernameFormatValid(username: string): boolean {
	if (!username) {
		return false
	}

	return USERNAME_REGEX.test(username)
}

export const NAME_REGEX = /^[a-z\s]+$/i

export const FIRST_NAME_VALIDATION_MESSAGE = 'First name should contain only alphabetic characters'

export const LAST_NAME_VALIDATION_MESSAGE = 'Last name should contain only alphabetic characters'

export const REFERRER_CODE_REGEX = /^[A-Za-z0-9]{8}$/

export const REFERRER_CODE_VALIDATION_MESSAGE = 'Referrer code must be exactly 8 alphanumeric characters'

const passwordSchema = z.string().regex(PASSWORD_REGEX, PASSWORD_VALIDATION_MESSAGE)

export const loginSchema = z.object({
	email: z.string().min(1, 'Email is required'),
	password: passwordSchema,
})

export const registerSchema = z
	.object({
		username: z.string().regex(USERNAME_REGEX, USERNAME_VALIDATION_MESSAGE),
		first_name: z.string().min(1, 'First name is required').regex(NAME_REGEX, FIRST_NAME_VALIDATION_MESSAGE),
		last_name: z.string().min(1, 'Last name is required').regex(NAME_REGEX, LAST_NAME_VALIDATION_MESSAGE),
		email: z.string().min(1, 'Email is required').email('Email must be valid'),
		password: passwordSchema,
		confirmPassword: z.string().min(1, 'Please confirm your password'),
		agreedToTerms: z.boolean().refine((value) => value, {
			message: 'You must agree to the Terms & Policy',
		}),
	})
	.refine((data) => data.password === data.confirmPassword, {
		message: 'Passwords do not match',
		path: ['confirmPassword'],
	})

export const forgotPasswordSchema = z.object({
	email: z.string().min(1, 'Email is required').email('Email must be valid'),
})

export const usernameSchema = z.object({
	username: z.string().trim().regex(USERNAME_REGEX, USERNAME_VALIDATION_MESSAGE),
	agreedToTerms: z.boolean().refine((value) => value, {
		message: 'You must agree to the Terms & Policy',
	}),
})

export type LoginFormValues = z.infer<typeof loginSchema>

export type RegisterFormValues = z.infer<typeof registerSchema>

export type ForgotPasswordFormValues = z.infer<typeof forgotPasswordSchema>

export type UsernameFormValues = z.infer<typeof usernameSchema>
